<div class="h-100 d-flex flex-column">
  <app-nav-bar [hidden]="hideHeader" [state]="navState" [user]="userName" [clientName]="clientName" />

  <div class="h-100 w-100">
    <div class="container-fluid h-100">
      <div class="row h-100">
        <div class="col loadingContainer">

          <!-- content -->
          <div class="col py-3">
            <div class="flex-grow-1 container" [ngClass]="{
              'chat-visible': supportChatService.isChatVisible && isLoggedIn,
              container: !isAdminPage()
            }">
              <router-outlet />
            </div>
            <div *ngIf="isLoggedIn && !isOffereePage() && !isOffersListPage()" class="chat-container position-absolute w-100">
              <app-popover-chat [hideFeedbackButton]="isOffereePage()" />
            </div>
          </div>


          <app-loading-overlay></app-loading-overlay>

        </div>
      </div>
    </div>
  </div>

  <app-notifications></app-notifications>
</div>
